import { render } from "./QueueComponent.vue?vue&type=template&id=6ad09d06&scoped=true"
import script from "./QueueComponent.vue?vue&type=script&lang=ts"
export * from "./QueueComponent.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-6ad09d06"

export default script